module.exports = __webpack_public_path__ + "static/media/brand.8bc1c050.svg";